module.exports = __webpack_public_path__ + "img/Graduated.79f3e6cb.svg";